package com.exura.features.demofeatures.domain.usecase

import com.exura.features.demofeatures.domain.DemoFeaturesConstants
import com.exura.features.demofeatures.domain.model.CheckFeatureEnabledRequest
import com.exura.features.demofeatures.domain.model.CheckFeatureEnabledResponse
import com.exura.features.demofeatures.domain.model.FeatureName
import dev.gitlive.firebase.functions.FirebaseFunctions

class CheckFeatureEnabledUseCase(
    private val functions: FirebaseFunctions,
) {
    suspend operator fun invoke(featureName: FeatureName): Result<Boolean> = runCatching {
        val callable = functions.httpsCallable(DemoFeaturesConstants.Functions.IS_FEATURE_ENABLED)
        val response = callable.invoke(CheckFeatureEnabledRequest(featureId = featureName.id))
        val result = response.data<CheckFeatureEnabledResponse>()
        result.isEnabled
    }
}
